import React from "react";
import {useState} from '../../../utils/ReactUtils';
import CalcService from "../../../services/CalcService";
import Button from "@mui/material/Button";
import {
  generateRUBSExport, generateInactiveTenantsExport, generateBillsImport
} from "../../../utils/ExportUtils";

const CalcGenXLS = (params) => {
  const {
    startDate,
    endDate,
    electricAdjustmentRate,
    reset,
    setErrorMessage,
  } = params;

  const [isLoading,setIsLoading] = useState(true,'loading');
  // generateXLS finalizes the run server-side (saves exports, queues
  // AppFolio charges/bills) — it must fire exactly once per mount, even
  // under React.StrictMode's dev double-mount
  const hasFired = React.useRef(false);

  React.useEffect( () => {
    if (!isLoading || hasFired.current) {
      return;
    }
    hasFired.current = true;
    const doCalculationCall = async () => {
      setIsLoading(true);
      const _data = (await CalcService.doCalculations({startDate,endDate,electricAdjustmentRate,dataset:'generateXLS'}))['data'];
      if (_data['error']) {
        setErrorMessage(_data['error'])
      } else {
        const generateExport = (key, func) => {
          const data = _data[key];
          const version = _data['versions'][key];
          func(data, startDate, endDate, version);
        }
        generateExport('generateXLS', generateRUBSExport);
        generateExport('generateXLS_inactiveTenants', generateInactiveTenantsExport);
        generateExport('billsImport', generateBillsImport);
      }
      setIsLoading(false);
    };
    doCalculationCall().catch(error => {
      setIsLoading(false);
      console.error(error);
      setErrorMessage(error.message ? error.message : "Unknown error; Check logs for more details.");
    });
  },[isLoading]);

  if (isLoading) {
    return <div>Loading...</div>
  }
  return <div>
    <div style={{display:"flex"}}>
      <Button onClick={reset}>Reset</Button>
    </div>
    <span>Your export has been generated. Tenant charges and vendor bills are queued and will post to AppFolio automatically.</span>
  </div>;
};

export default CalcGenXLS;